import { render } from "./PointsOfInterestCategories.vue?vue&type=template&id=125e4d17&scoped=true"
import script from "./PointsOfInterestCategories.vue?vue&type=script&lang=js"
export * from "./PointsOfInterestCategories.vue?vue&type=script&lang=js"

import "./PointsOfInterestCategories.vue?vue&type=style&index=0&id=125e4d17&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125e4d17"]])

export default __exports__